import FlightInterface from '../../interfaces/client/Flight'

import getAvailableAmountOfSeats from './getAvailableAmountOfSeats'

export default (getTravelClassFilter: any) => (
  departureFlight: FlightInterface,
  returnFlight: FlightInterface
) => {
  const departureTravelClassCounts =
    departureFlight && departureFlight.travelClassSeatCounts
      ? departureFlight.travelClassSeatCounts
      : []

  const departureClassAllotment = departureTravelClassCounts
    .filter(getTravelClassFilter)
    .map(getAvailableAmountOfSeats)

  if (!returnFlight) return departureClassAllotment[0]

  const returnTravelClassCounts =
    returnFlight && returnFlight.travelClassSeatCounts
      ? returnFlight.travelClassSeatCounts
      : []

  const returnClassAllotment = returnTravelClassCounts
    .filter(getTravelClassFilter)
    .map(getAvailableAmountOfSeats)

  if (!departureClassAllotment.length && !returnClassAllotment.length) return

  return Math.min(...departureClassAllotment, ...returnClassAllotment)
}
